import { Component, OnInit, Input, Output, EventEmitter, Directive } from '@angular/core';
import { ScreeningService } from 'src/app/services/screening.service';

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.less']
})
export class DropDownComponent implements OnInit {
  @Input() property : string;
  @Input() model : any;
  @Input() label : string;
  @Input() valueLabel : string;
  @Input() values : Array<any>;
  @Output() modelChanged = new EventEmitter<any>();

  constructor(private screeningSrv : ScreeningService) { }

  ngOnInit() {
    console.log(this.values)
  }

  onChange()
  {
    // console.log(this.model);
    this.modelChanged.emit({
      name: this.property,
      value: this.model
    })
  }
}
